module.exports = __webpack_public_path__ + "static/img/sliderHomePage.e58b865.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/newWx/sliderHomePage.png
// module id = jPwp
// module chunks = 0